import { Component, ElementRef, OnInit, ViewChild, HostBinding } from '@angular/core';
import { MatSnackBar, MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';
import { AuthloginService, AuthService, ProjectService } from 'dbweb-core';
import { Md5 } from 'ts-md5';

@Component({
	selector: 'common-app-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
	userName: string;
	password: string;
	hide = true;
	eyehide = true;

	@HostBinding('class.login') hostClass = true;
	@ViewChild('username', { static: false })
	username: ElementRef;
	@ViewChild('edtPassword', { static: false }) // è®¿é®ä»ç»ä»¶ä¸­è®¿é®æ¨¡æ¿ä¸­ä¹¦åçDOMãå­ç»ä»¶åæä»¤çåè½
	// è®¿é®ä»ç»ä»¶ä¸­è®¿é®æ¨¡æ¿ä¸­ä¹¦åçDOMãå­ç»ä»¶åæä»¤çåè½
	pwd: ElementRef;
	@ViewChild('btnOk', { read: ElementRef, static: false })
	btnOk: ElementRef;
	snack: MatSnackBarRef<SimpleSnackBar>;
	logging = false;
	constructor(
		public auth: AuthService,
		public project: ProjectService,
		public snackBar: MatSnackBar,
		public authLogin: AuthloginService
	) {}
	userNameEnter() {
		this.pwd.nativeElement.focus();
	}
	passwordEnter() {
		this.btnOk.nativeElement.click();
	}
	btnOkClick() {
		if (this.snack) {
			this.snack.dismiss();
		}
		if (!this.password || !this.userName) {
			this.snack = this.snackBar.open('ç¨æ·åæå¯ç ä¸è½ä¸ºç©º', 'ç¡®å®', {
				verticalPosition: 'top',
				duration: 5000
			});
			return;
		}
		this.logging = true;
		this.auth.login({ UserName: this.userName, Md5Password: Md5.hashStr(this.password) as string }).subscribe(
			n => {
				this.authLogin.loginDefault(n);
				this.logging = false;
			},
			err => {
				console.log(err);
				this.logging = false;
				this.snack = this.snackBar.open('ç¨æ·åæå¯ç éè¯¯', 'ç¡®å®', { verticalPosition: 'top' });
			}
		);
	}

	ngOnInit() {}

	refresh() {
		window.location.reload();
	}
}
